/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateOrganization200ResponseContractsInner } from './update-organization200-response-contracts-inner';

/**
 * 
 * @export
 * @interface UpdateOrganization200Response
 */
export interface UpdateOrganization200Response {
    /**
     * 
     * @type {number}
     * @memberof UpdateOrganization200Response
     */
    'id': number;
    /**
     * 
     * @type {Array<UpdateOrganization200ResponseContractsInner>}
     * @memberof UpdateOrganization200Response
     */
    'contracts': Array<UpdateOrganization200ResponseContractsInner>;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'orgAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'invoiceEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isApprovalFeatureEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isBlacklisted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isSendTransactionFailureEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isVCCooperationPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'promotionCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'paymentScheme': UpdateOrganization200ResponsePaymentSchemeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'identityVerificationScheduledDate'?: string | null;
}

export const UpdateOrganization200ResponsePaymentSchemeEnum = {
    fifteenthDayPayment: 'FIFTEENTH_DAY_PAYMENT',
    endOfMonthPayment: 'END_OF_MONTH_PAYMENT',
    twoMonthsLaterFifteenthDayPayment: 'TWO_MONTHS_LATER_FIFTEENTH_DAY_PAYMENT',
    twoMonthsLaterSixthDayPayment: 'TWO_MONTHS_LATER_SIXTH_DAY_PAYMENT',
    endOfTwoMonthsLaterPayment: 'END_OF_TWO_MONTHS_LATER_PAYMENT'
} as const;

export type UpdateOrganization200ResponsePaymentSchemeEnum = typeof UpdateOrganization200ResponsePaymentSchemeEnum[keyof typeof UpdateOrganization200ResponsePaymentSchemeEnum];


